import { Box } from "@mui/material";
import React from "react";
import Loader from "./Loader";

export const modalLoadingContainerSx = (loading, sx = {}) => ({
  ...sx,
  position: sx.position || "relative",
  ...(loading
    ? {
        "& > :not(.modal-loading-overlay)": {
          pointerEvents: "none",
          userSelect: "none",
        },
      }
    : {}),
});

const ModalLoadingOverlay = ({ open }) => {
  if (!open) return null;

  return (
    <Box
      className="modal-loading-overlay"
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: "inherit",
        pointerEvents: "all",
        "& > div": {
          width: "auto",
          height: "auto",
        },
      }}
    >
      <Loader />
    </Box>
  );
};

export default ModalLoadingOverlay;
